import { apiClient } from './AbstractHTTPService'

const PATH = '/userregister/'

export default {
  getData () {
    return apiClient.get('/user/my/')
  },
  register (user) {
    return apiClient.post(PATH, user)
  },
  update (user) {
    return apiClient.put(PATH + user.id + '/', user)
  },
  validateEmail (token) {
    return apiClient.post(PATH, { token: token })
  },
  passwordForgotten (data) {
    return apiClient.post('/passwordforgotten/', data)
  },
  deleteAccount () {
    return apiClient.delete(PATH + '0/')
  }
}
